import { styled } from "../../../../../../styles";

export const GraphContainer = styled("div", {
  width: "100%",
  height: "67%",

  // Mirror the regular ChartCard: shrink the plot when empty and dim it, so the
  // footer values line up with the other measurement cards instead of sitting lower.
  variants: {
    isEmpty: {
      true: {
        height: "57%",
        opacity: 0.36,
      },
    },
  },
});

export const GraphLegend = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",

  marginBottom: "2px",
});
